import script from "./PgmDashBoard.vue?vue&type=script&setup=true&lang=ts"
export * from "./PgmDashBoard.vue?vue&type=script&setup=true&lang=ts"

import "./PgmDashBoard.vue?vue&type=style&index=0&id=c81dd440&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c81dd440"]])

export default __exports__